export default __webpack_public_path__ + "static/media/island-symbol-storm-architecture-manhattan.3451d954.jpg";